import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { highestProductLevel } from 'pricing-pages-lib/utils/productsUtils';
import { useSelector } from 'react-redux';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { tabIdToProductLevels } from '../../constants/routing/Tabs';
import { CALCULATOR } from '../../constants/tracking/Locations';
import { usePageParams } from '../../hooks/usePageParams';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { highestProductLevelFromProductInventorySelector, productsFromProductInventoryQuantitySelector } from '../../selectors/ProductInventorySelectors';
import { currentSkuIdForProductSelector, lowestPaidProductLevelFromListSelector, lowestPaidProductLevelSelector, skuSelector } from '../../selectors/ProductsSelectors';
import AddonsAndServicesPickerList from '../plan-builder/AddonsAndServicesPickerList';
import HubPlanPickerList from '../plan-builder/HubPlanPickerList';
import Calculator from './Calculator';
import { Section } from '../common/SharedComponents';
export const ProductCalculator = ({
  productLine,
  screen,
  className = ''
}) => {
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const {
    tab
  } = usePageParams();
  const initialSkuId = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded) return null;
    const isPublic = !isAppAuthSelector(state);
    let lowestPaidProductLevel;

    if (isPublic) {
      lowestPaidProductLevel = lowestPaidProductLevelFromListSelector(state, {
        productLine,
        productLevels: tabIdToProductLevels[tab]
      });
    } else {
      lowestPaidProductLevel = lowestPaidProductLevelSelector(state, {
        productLine
      });
    }

    const productLevel = highestProductLevel(lowestPaidProductLevel || FREE, highestProductLevelFromProductInventorySelector(state, {
      productLine
    }));
    return currentSkuIdForProductSelector(state, {
      productLine,
      productLevel
    });
  });
  const ownedSkuQuantity = useAppSelector(state => {
    if (initialSkuId) {
      return productsFromProductInventoryQuantitySelector(state, {
        skuId: initialSkuId
      });
    }

    return 0;
  });
  const zeroStateProductConfigs = useAppSelector(state => {
    if (!initialSkuId) return [];
    const {
      quantityPackDetails
    } = skuSelector(state, {
      skuId: initialSkuId
    });
    return quantityPackDetails.map(({
      skuId
    }) => createProductConfig({
      skuId,
      quantity: 0
    }));
  });
  return /*#__PURE__*/_jsx(Section, {
    hideOverflow: false,
    children: /*#__PURE__*/_jsx(Calculator, {
      className: className,
      planBuilderProps: {
        initialProductConfigurations: initialSkuId ? [createProductConfig({
          skuId: initialSkuId,
          quantity: ownedSkuQuantity || 1
        })] : [],
        requiredProductLines: [productLine],
        zeroStateCheckoutProductConfigs: zeroStateProductConfigs,
        trackingSource: CALCULATOR,
        screen,
        showDiscountedPricesInUnitsPicker: true
      },
      planSelectorComponent: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HubPlanPickerList, {
          compact: true,
          productLines: [productLine]
        }), /*#__PURE__*/_jsx(AddonsAndServicesPickerList, {
          compact: true,
          defaultOpen: false,
          showServicesSection: false,
          screen: screen,
          showLeadingDivider: true
        })]
      })
    })
  });
};